﻿package com.milta.core.localization.translations.nl

import com.milta.core.localization.ProfileStrings

internal val Profile = ProfileStrings(
    screenTitle = "Mijn profiel",
    sectionPersonal = "Persoonlijke informatie",
    labelFirstName = "Voornaam",
    labelLastName = "Achternaam",
    labelRole = "Rol",
    sectionLanguage = "Taal",
    labelLanguage = "Taal van de app",
    changeLanguageButton = "Taal wijzigen",
    languageDialogTitle = "Kies uw taal",
    languageDialogConfirm = "Bevestigen",
    languageDialogCancel = "Annuleren",
    sectionPassword = "Beveiliging",
    labelCurrentPassword = "Huidig wachtwoord",
    labelNewPassword = "Nieuw wachtwoord",
    changePasswordButton = "Wachtwoord wijzigen",
    successLanguageUpdated = "Taal succesvol bijgewerkt",
    successPasswordChanged = "Wachtwoord succesvol gewijzigd",
    errorProfileNotFound = "Profiel niet gevonden",
    errorCurrentPasswordRequired = "Voer uw huidige wachtwoord in",
    errorCurrentPasswordTooLong = "Huidig wachtwoord mag niet langer zijn dan 128 tekens",
    errorNewPasswordRequired = "Voer een nieuw wachtwoord in",
    errorNewPasswordTooShort = "Nieuw wachtwoord moet minimaal 8 tekens bevatten",
    errorNewPasswordTooLong = "Nieuw wachtwoord mag niet langer zijn dan 128 tekens",
    errorLanguageRequired = "Selecteer een taal",
    errorForbidden = "U bent niet gemachtigd om deze actie uit te voeren",
    errorValidation = "De opgegeven gegevens zijn ongeldig",
    errorGeneric = "Er is een fout opgetreden. Probeer opnieuw.",
    signOut = "Afmelden",
    deleteAccount = "Account verwijderen",
    menuLanguage = "Interfacetaal",
    menuPassword = "Wachtwoord wijzigen",
    menuSubscription = "Mijn abonnement",
    menuPrivacy = "Privacy & AVG",
    linkedCodeLabel = "Unieke koppelcode",
    copyCode = "Kopiëren",
    codeCopied = "Gekopieerd!",
    modeOrganisation = "Bedrijf",
    modeDriver = "Chauffeur",
    roleDriver = "Chauffeur",
    roleOrganisation = "Bedrijf",
    modeSwitchTitle = "Modus wisselen",
    modeSwitchHint = "Wissel op elk moment tussen Bedrijfsmodus en Chauffeursmodus",
    switchToEnterprise = "Bedrijfsmodus",
    switchToDriver = "Chauffeursmodus",
    menuPhone = "Telefoonnummer",
    phoneOtpStepTitle = "Verificatiecode per sms verzonden",
    successPhoneUpdated = "Telefoonnummer bijgewerkt",
    deleteAccountDialogTitle = "Uw account verwijderen?",
    deleteAccountDialogMessage = "Deze actie is onomkeerbaar. Uw persoonlijke gegevens worden verwijderd. Ter bevestiging wordt een verificatiecode per sms verzonden.",
    deleteAccountDialogConfirm = "Doorgaan",
    deleteAccountOtpStepTitle = "Verificatiecode per sms verzonden",
    deleteAccountConfirmButton = "Definitief verwijderen",
    errorLastEnterpriseOwner = "U bent de enige beheerder van uw bedrijf. Voeg een ander bedrijfsaccount toe voordat u het uwe verwijdert.",
    logoutPendingWarningTitle = "Niet-verzonden leveringen",
    logoutPendingWarningMessageSuffix = "levering(en) in wachtrij gaan verloren als je nu uitlogt.",
    logoutPendingWarningConfirm = "Toch uitloggen",
    logoutPendingWarningCancel = "Annuleren",
    modeSwitchActiveRouteWarningTitle = "Rit bezig",
    modeSwitchActiveRouteWarningMessage = "Er is momenteel een rit bezig. Als u van modus wisselt, verlaat u de opvolging ervan. Doorgaan?",
    modeSwitchActiveRouteWarningConfirm = "Toch wisselen",
    modeSwitchActiveRouteWarningCancel = "Annuleren",
)

